export default __webpack_public_path__ + "static/media/se.27c48305.svg";